var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummarySectionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 123,
    viewBox: "0 0 183 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36eboa2dua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.119 121.248c32.322 0 58.525-26.203 58.525-58.64 0-32.438-26.319-58.641-58.525-58.641-32.322 0-58.525 26.203-58.525 58.64 0 32.438 26.203 58.641 58.525 58.641z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.074 44.028a4.733 4.733 0 1 0-.001-9.466 4.733 4.733 0 0 0 .001 9.466zM164 25.558a3.232 3.232 0 1 0 0-6.464 3.232 3.232 0 0 0 0 6.464zm-128.751-1.39a3.232 3.232 0 1 0 0-6.465 3.232 3.232 0 0 0 0 6.464zm-19.74 62.334a6.003 6.003 0 1 0 0-12.005 6.003 6.003 0 0 0 0 12.005z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.066 93.906-46.39 9.516c-.678.106-1.3-.247-1.406-.925L13.124 33.248c-.105-.678.247-1.3.925-1.405l46.39-9.517c.678-.105 1.3.247 1.405.925l14.223 69.246c.102.602-.323 1.303-1.001 1.409z",
    fill: "#fff",
    stroke: "#C5CCDA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.21 74.657 3.987-.82M25.89 66.634l18.15-3.73-18.15 3.73zm23.562-4.825 3.986-.819-3.986.819zm8.826-1.818 3.986-.82-3.986.82zM26.892 71.545l18.151-3.73-18.151 3.73zm23.56-4.897 3.989-.747-3.99.747zm8.757-1.743 3.986-.82-3.986.82zM27.89 76.385l18.152-3.73-18.151 3.73zm23.562-4.825 3.987-.819-3.987.819zm8.755-1.815 3.986-.82-3.986.82zM28.89 81.225l18.154-3.657-18.154 3.658zm2.818 13.667 5.124-1.083-5.124 1.083zm-.73-3.56 9.114-1.83-9.113 1.83zm28-3.509 9.042-1.827-9.041 1.827zM52.454 76.4l3.986-.819-3.986.819z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.023 40.292c-1.562.329-2.653 1.663-2.833 3.29-.055.357.202.648.542.714.34.067.611-.197.667-.554.104-1.058.889-1.983 1.889-2.193 1-.21 2.077.254 2.612 1.246.194.305.549.438.833.24.285-.199.403-.569.209-.873-.834-1.483-2.356-2.199-3.919-1.87zm14.343-3.016c-1.563.328-2.653 1.663-2.834 3.29-.055.356.202.648.543.714.34.067.61-.197.666-.554.104-1.058.889-1.983 1.889-2.193 1-.21 2.077.254 2.612 1.246.195.305.549.437.834.24.284-.199.402-.569.208-.873-.834-1.483-2.355-2.199-3.918-1.87zm-9.527 8.44.903-.197c1.129 1.501 3.28 1.687 4.697.505.565-.415 1-1.092 1.14-1.778l.904-.197c-.294 2.321-2.554 3.979-4.82 3.6a4.277 4.277 0 0 1-2.824-1.933z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.88 48.24a2.443 2.443 0 1 0-1.006-4.781 2.443 2.443 0 0 0 1.006 4.782zM31.39 52.55a2.443 2.443 0 1 0-1.005-4.782 2.443 2.443 0 0 0 1.005 4.781z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.239 113.563-51.18 2.997c-.738.077-1.308-.501-1.385-1.24l-4.457-76.277c-.077-.739.501-1.308 1.24-1.385l51.179-2.997c.739-.077 1.309.501 1.385 1.24l4.458 76.278c-.005.737-.501 1.308-1.24 1.384z",
    fill: "#fff",
    stroke: "#C5CCDA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.716 102.585 8.963-.496M84.653 78.675l24.579-1.435-24.58 1.435zm-.248-4.482 24.509-1.435-24.51 1.435zm.496 8.963 24.579-1.434-24.58 1.434zm-11.236 5.1 36.064-2.123-36.064 2.123zm.248 4.481 20.618-1.252-20.618 1.252zm.887 14.976 5.112-.313-5.112.313zm-.185-3.501 9.034-.565-9.034.565z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.192 84.108c-.07 0-.14 0-.14-.07l-1.175-2.528-4.416.244-.858 2.65c0 .07-.07.14-.14.139l-.912.062c-.07 0-.14-.001-.14-.071-.07-.07-.07-.07.001-.14l3.143-9.554c0-.07.07-.14.14-.139l1.262-.06c.07.001.14.002.14.072l4.288 9.126-.001.14c0 .07-.07.069-.14.068l-1.052.061zm-5.444-3.54 3.575-.181-2.074-4.562-1.5 4.742z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.416 51.655c1.074-.069 1.935-1.048 1.867-2.122-.069-1.074-1.048-1.936-2.122-1.867-1.074.069-1.936 1.048-1.867 2.122.073 1.15.971 1.94 2.122 1.867zm-15.513 1.014c1.074-.068 1.936-1.047 1.867-2.121-.068-1.075-1.048-1.936-2.122-1.868-1.074.069-1.935 1.048-1.867 2.122.15 1.146 1.048 1.936 2.122 1.867zm4.575 3.584c.188 1.774 1.664 3.11 3.373 3.013 1.71-.096 3.025-1.589 3.013-3.372l-6.386.36z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.693 61a2.642 2.642 0 1 0-.297-5.275 2.642 2.642 0 0 0 .297 5.275zM80.079 62.275a2.642 2.642 0 1 0-.298-5.276 2.642 2.642 0 0 0 .298 5.276z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.543 80.023 124.63 91.515c-.662.181-1.309-.214-1.49-.876l-17.147-68.538c-.181-.662.214-1.309.876-1.49l45.913-11.492c.662-.181 1.308.214 1.49.876l17.146 68.538c.182.662-.214 1.309-.875 1.49z",
    fill: "#fff",
    stroke: "#C5CCDA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.568 67.03 37.107-9.336m-41.442-7.812 5.691 22.709 37.153-9.311-5.691-22.709-37.153 9.311zm8.307 32.95 5.23-1.283-5.23 1.282zm-.956-3.607 9.277-2.334-9.277 2.334zm28.748-4.896 9.277-2.334-9.277 2.334zm-27.021-26.645 5.678 22.696-5.678-22.696zm9.484-2.416 5.747 22.669-5.747-22.67zm9.579-2.375 5.678 22.696-5.678-22.696zm-26.659 12.755 37.107-9.337-37.107 9.337zm1.379 5.67 37.134-9.267-37.134 9.268z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.142 25.747c-1.863.45-3.122 2.09-3.28 4.047-.054.43.265.77.676.838.411.068.726-.259.78-.69.086-1.272.994-2.41 2.186-2.698 1.192-.288 2.501.23 3.178 1.402.245.358.674.504 1.009.257.334-.248.462-.696.218-1.055-1.054-1.747-2.904-2.552-4.767-2.101zm12.55-3.035c-1.707.413-2.837 2.021-2.945 3.967a.787.787 0 0 0 .639.847c.38.075.664-.244.705-.671.056-1.266.871-2.38 1.963-2.645 1.093-.264 2.308.277 2.955 1.456.232.36.63.515.934.274a.787.787 0 0 0 .181-1.045c-1.004-1.76-2.724-2.596-4.432-2.183zm-2.65 14.283a2.093 2.093 0 1 0-.983-4.07 2.093 2.093 0 0 0 .983 4.07z",
    fill: "#AAB2C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "36eboa2dua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .266)",
    d: "M0 0h183v122H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarySectionImg);
export default __webpack_public_path__ + "static/media/summary-section-img.46d64cb195caff345c0023be9a4346a1.svg";
export { ForwardRef as ReactComponent };